import React from "react";
import {Switch} from "antd";
import cn from "classnames";
import {Info} from "components/Info";

const CustomRadioSwitch = ({
  label,
  small,
  isActive,
  addClass,
  addWrapperClass,
  wrapperStyle,
  uppercase,
  mediumText,
  largeText,
  bold,
  redOnColor,
  checked,
  disabled,
  defaultChecked,
  isDisabledLabel,
  informationText,
  labelOffset = 2, // offset between toggle and label (number * 5px)
  prefixLabelContent,
}) => {
  return (
    <div
      className={cn("custom-switch_wrapper", {
        [addWrapperClass]: !!addWrapperClass,
      })}
      style={wrapperStyle}
    >
      <Switch
        className={cn("selections-group_switch__check custom-switch-check", {
          [addClass]: !!addClass,
          "__red-on": !!redOnColor,
        })}
        size={small ? "small" : "default"}
        checked={checked}
        disabled={disabled}
        defaultChecked={defaultChecked}
        onChange={isActive}
      />
      {prefixLabelContent}
      {label && (
        <label
          className={cn("custom-switch_label", {
            [`ml-${labelOffset}`]: !!labelOffset,
            __uppercase: !!uppercase,
            __small: !!small,
            __medium: !!mediumText,
            __large: !!largeText,
            __bold: !!bold || (!!small && !(mediumText || largeText)),
            __grey: isDisabledLabel,
          })}
        >
          {label}
        </label>
      )}
      {informationText && <Info tooltip={informationText} centerText addClass="ml-2" />}
    </div>
  );
};

export default CustomRadioSwitch;
